var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',[_c(_setup.PageTitle,{attrs:{"main":_vm.$t('createIndicators'),"sub":"","imagem":"add.png"}}),_c(_setup.TabStructure,{attrs:{"isCreating":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }